import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import _ from 'lodash';
import { prepareTwoDMapData, generatedTwoDMapData } from "../../../action/twoDMap.action";
import { const_var } from "../../../redux/reducers/reducer";


class TwoDFloorplanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenSVG: false,
      isOpenPDF: false,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      isReady: false,
      hideTimer: null
    };
    this.ref = React.createRef();
    this.options = {
      orientation: "landscape",
      unit: "in",
      format: [4, 2],
    };
    this.prevBuildingInfo = null;
    this.handleMessage = this.handleMessage.bind(this);
  }

  async draw2DLayout() {
    let buildingInfo = const_var.post_data?.building !== undefined && const_var.post_data.building?const_var.post_data.building:null;
    const floorplanner = document.getElementById("floorplanner-"+this.props.purpose);
    if ( floorplanner && buildingInfo && floorplanner.contentWindow) {
      let data = JSON.parse(JSON.stringify(buildingInfo));
      let reverse = ["rside", "llbend", "bend", "fsrside", "flfend", "blbside", "blfend", "llbend", "llbend", "llrside",
        "rlbend", "rlrside", "lubend", "rubend", "llurside", "rrurside", "flurside", "rlrside", "lllside", "rlbend", "rlbend", "rlrside"];
      if ("entry_points" in buildingInfo) {
        for(let i=0; i<buildingInfo.entry_points.length; i+=1) {
          let reflect = 1;
          if (reverse.includes(buildingInfo.entry_points[i].entry_location))
            reflect = -1;
          buildingInfo.entry_points[i].entry_position.x = const_var.newDoorsArray[i].positionX * reflect;
          buildingInfo.entry_points[i].entry_position.z = const_var.newDoorsArray[i].positionX * reflect;
        }
      }
      if (this.props.purpose === 'save') {
        let floorPromise = new Promise(function(myResolve, myReject) {
            let count = 0;
            function check2DImage() {
              myResolve();
            }
            setTimeout(check2DImage, 5000);
        });
        await floorPromise.then(function(val) {}, function(val) {});
		buildingInfo = const_var.post_data?.building !== undefined && const_var.post_data.building?const_var.post_data.building:null;
        data = JSON.parse(JSON.stringify(buildingInfo));
        data.layout2DMapId = this.props.twoDMapData.layout2DMapId;
        data.frameId = 'auto';
      }
      else
        data.frameId = 'req';
      floorplanner.contentWindow.postMessage({
          "type": "buildingInfo",
          "data": data}, '*');
    }
  }

  requestImage() {
    const floorplanner = document.getElementById("floorplanner-"+this.props.purpose);
    floorplanner.contentWindow.postMessage({
      "type": "image"
    }, '*');
  }

  handleMessage(obj, e) {
    if (e.data === "ready")
    {
      obj.setState({ isReady: true });
      obj.draw2DLayout();
    }
    else if (e.data && e.data.type == "image")
    {
      if (e.data.requestType === 'auto') {
        window.twoDMapAutoPng = e.data.png;
        window.twoDMapAutoSvg = e.data.svg;
        this.props.generatedTwoDMapData(e.data.layout2DMapId);
      } else if (e.data.requestType === 'req') {
        if (window.twoDMapReqPng) {
          if (e.data.png != window.twoDMapReqPng[0]) {
            window.twoDMapReqPng.unshift(e.data.png);
            const_var.twoDImageObj.unshift({'image':e.data.png,'is_checked':false});
            window.twoDMapReqSvg.unshift(e.data.svg);
            if (window.twoDMapReqPng.length > 5) {
              window.twoDMapReqPng.pop();
              const_var.twoDImageObj.pop();
              window.twoDMapReqSvg.pop();
            }
          }
        } else {
          window.twoDMapReqPng = [e.data.png];
          window.twoDMapReqSvg = [e.data.svg];
        }
        if (obj.props.purpose !== 'save')
          obj.props.hideFloorplanner();
      }
    }
    else if (e.data && e.data.type == "message" && obj.props.purpose !== 'save')
    {
      if (e.data.requestType === 'close') {
        const floorplanner = document.getElementById("floorplanner-"+this.props.purpose);
        floorplanner.contentWindow.postMessage({
          "type": "image"
        }, '*');
      }
      if (e.data.requestType === 'drewLayout') {
        const spinner = document.getElementById("floorplanner-spinner-"+this.props.purpose);
        if(spinner!=null){
              spinner.style.display = "none";
        }
        if (this.state.hideTimer !== null) {
          clearTimeout(this.state.hideTimer);
          this.setState({hideTimer: null});
        }
      }
    }
  }

  hideSpinner() {
    const spinner = document.getElementById("floorplanner-spinner-"+this.props.purpose);
    if (spinner)
      spinner.style.display = "none";
    this.setState({hideTimer: null});
  }
  onResize = () => {
    this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    this.forceUpdate();
    // this.setState(() => ({ windowWidth: window.innerWidth, windowHeight: window.innerHeight }), () => {
    //   this.forceUpdate();
    // });
  }
  componentDidMount() {
     this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    window.addEventListener('resize', this.onResize);
    window.addEventListener("message", (e) => this.handleMessage(this, e));
    if (this.props.purpose !== 'save') {
      const hideTimer = window.setTimeout(() => this.hideSpinner(), 15000);
      this.setState({hideTimer: hideTimer});
      const spinner = document.getElementById("floorplanner-spinner-"+this.props.purpose);
      spinner.classList.add("spinner-active");
    }
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }
  removeEmpty(obj) {
    let newObj = {};
    Object.keys(obj).forEach((key) => {
      if (obj[key] === Object(obj[key])) newObj[key] = this.removeEmpty(obj[key]);
      else if (obj[key] !== undefined) newObj[key] = obj[key];
    });
    return newObj;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.twoDMapData.layout2DMapId !== this.props.twoDMapData.layout2DMapId)
    {
      this.draw2DLayout();
    }
  }

  render() {
    return (
      <>
        <div className="fullpage-loader spinner-loader" id={"floorplanner-spinner-"+this.props.purpose}>
          <div className="spinner-loader">
             <div className="spinner"></div>
          </div>
          <div className="spinner-content">
           <h6>Please wait...</h6>
           <p className="barlow-medium">We're preparing 2D Drawing</p>
          </div>
        </div>
        <iframe src="https://cdn.sensei3d.com/floorplanner_v4/index.html"  className="second-row" id={"floorplanner-"+this.props.purpose} style={{'flex-grow': 1, border: 'none', margin: 0, padding: 0, height: this.state.windowHeight, width: this.state.windowWidth}}> </iframe>
      </>
    );
  }
}
const mapDispatchToProps = {
  prepareTwoDMapData,
  generatedTwoDMapData
};
const mapStateToProps = (state) => {
  return { 
    twoDMapData: state.componentReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TwoDFloorplanner);
